import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { ActiveAdminService } from '../common/active-admin.service';
import { HttpService } from './http.service';
import { LocalStorageService } from '../common/local-storage.service';
import { AdminLoginInput, ChangeAdminEmailInput, ChangeAdminPasswordInput, CustomerLoginInput, ResetAdminPasswordInput } from '../../inputs';
import { SubmitResponse } from '@sgm-frontend/core';
import { AdminLoginResponse, CustomerLoginResponseDetail } from '../../models/common/app-token.model';

@Injectable({
  providedIn: 'root'
})
export class AdminAuthService extends HttpService<
  AdminLoginInput | ChangeAdminEmailInput | ChangeAdminPasswordInput | ResetAdminPasswordInput | { email: string },
  AdminLoginResponse | SubmitResponse
> {
  constructor(
    httpClient: HttpClient,
    private readonly router: Router,
    @Inject('API_URL') apiUrl: string,
    @Inject('API_VERSION') apiVersion: string,
    private jwtService: JwtHelperService,
    private activeAdminService: ActiveAdminService,
    private localStorageService: LocalStorageService
  ) {
    super(httpClient, apiUrl, apiVersion, 'staff');
    this.isAuthenticated();
  }

  isAuthenticated = (): boolean => {
    const token = this.localStorageService.getAdminToken();
    if(token){
      return true;
    //   if (this.jwtService.isTokenExpired(token)) {
    //   // this.logOut();
    //   return false;
    // }
    }else{
      return false;
    }
    
  };

  authenticate(login: AdminLoginInput): Observable<void> {
    return this.create(login, 'login').pipe(
      map(({ data }) => {
        if (data?.token) {
          this.localStorageService.setToken(data.token);
          this.activeAdminService.setActiveAdmin(data.user);
          this.router.navigate(['/']);
        }
      })
    );
  }
  authenticateAdmin(login: CustomerLoginInput): Observable<any> {
    // Call the create method, which now returns HttpResponse<CustomerLoginResponse>
    return this.createAdminHttpRes(login, 'auth/login').pipe(
      tap((res: HttpResponse<CustomerLoginResponseDetail>) => { // 'res' is now a HttpResponse object
        // Check the status code
        if (res.status === 200) {
          if (res.body) {
            this.localStorageService.setToken({ accessToken: res.body.data.accessToken, refreshToken: res.body.data.refreshToken });
            // this.activeUserService.setActiveUser();
            // this.localStorageService.setUserInfo(this.activeUserService.getActiveUser());
          }
        }
      }),
      map((res: HttpResponse<any>) => res),
      catchError((error) => {
      // Pass error to subscriber
      return throwError(() => error);
    })
    );
  }

  sendResetPasswordEmail(email: string): Observable<unknown> {
    return this.create({ email }, 'resetPassword');
  }

  changeEmail(changeEmailInput: ChangeAdminEmailInput): Observable<unknown> {
    return this.update(changeEmailInput, 'changeEmail');
  }

  resetPassword(resetPasswordInput: ResetAdminPasswordInput): Observable<unknown> {
    return this.update(resetPasswordInput, `resetPassword`);
  }

  changePassword(staffId: string, changePasswordInput: ChangeAdminPasswordInput): Observable<unknown> {
    return this.update(changePasswordInput, `changePassword?staff_id=${staffId}`);
  }

  logOut(): void {
    this.localStorageService.clearAdminTokens();
    // this.activeAdminService.clearActiveAdmin();
    this.router.navigate(['auth']);
  }
}
